var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"vip-introdution"},[(_vm.isVip)?_c('VipHeader'):_c('NotVipHeader'),_c('VipContent'),(!_vm.isVip)?_c('NotVipBottom'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }